import {Endpoint} from '@eryxcoop/appyx-comm';

export default class EditOrCreateCustomerOnboardingUserRequestEndpoint extends Endpoint {

    adaptValues({
                    taxpayerIdentificationNumber,
                    userOnboardingRequest,
                }) {
        return {
            taxpayer_identification_number: taxpayerIdentificationNumber,
            user_onboarding_request_external_id: userOnboardingRequest.id,
            email: userOnboardingRequest.email,
            delivery_site_onboarding_requests_external_ids: userOnboardingRequest.deliverySiteOnboardingRequests,
            roles: userOnboardingRequest.roles,
        };
    }
}
